<template>
  <v-dialog max-width="300" persistent v-model="show">
    <v-card>
      <v-time-picker
        width="300"
        v-model="timePicker"
        format="24hr"
      ></v-time-picker>
      <v-card-actions>
        <v-btn @click="submit" :disabled="!selectionComplete">Submit</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'TimePicker',
  data: () => ({
    show: true,
    timePicker: null
  }),
  props: ['autoPick'],
  watch: {
    timePicker() {
      if (this.timePicker && this.autoPick) {
        this.$emit('pick', this.timePicker.toString())
      }
    }
  },
  methods: {
    submit() {
      this.$emit('pick', this.timePicker.toString())
    },
    close() {
      this.$emit('close')
    }
  },
  computed: {
    selectionComplete() {
      return this.timePicker
    }
  }
}
</script>

<style scoped></style>
